module.exports = __webpack_public_path__ + "img/img_32 - 副本.575a22db.png";